<template>
    <div>
        
        <div class="form-group row">
            <label class="col-form-label col-sm-3">{{translate('targetSystem.email.to')}}:</label>
            <div class="col-sm-9">
                <vue-tags-input
                    v-model="to"
                    :tags="value.To || []"
                    :placeholder="translate('emailAddress')"
                    @tags-changed="newTags => value.To = newTags.map(x => x.text.toLowerCase())"
                    :save-on-key="[13]"
                    :seperators="[':', ';', ' ']"
                    :addOnKey="[9, 13, 32, 44, 58, 59]"
                    :allow-edit-tags="true"
                    :allow-duplicates="false"
                    @before-adding-tag="checkEmail"
                    @input="handleTo"
                />
            </div>
        </div>
        <div class="text-right" v-show="!showCc()">
            <button @click="toggleCC = true" type="button" class="btn btn-link" :title="translate('targetSystem.email.addCCTitle')">{{translate('targetSystem.email.addCC')}}</button>
        </div>
        <div v-if="toggleCC" class="form-group row" >
            <label class="col-form-label col-sm-3">CC:</label>
            <div class="col-sm-9">
                <vue-tags-input
                    v-model="cc"
                    :tags="value.Cc || []"
                    :placeholder="translate('emailAddress')"
                    @tags-changed="newTags => value.Cc = newTags.map(x => x.text.toLowerCase())"
                    :save-on-key="[13]"
                    :seperators="[':', ';', ' ']"
                    :addOnKey="[9, 13, 32, 44, 58, 59]"
                    :allow-edit-tags="true"
                    :allow-duplicates="false"
                    @before-adding-tag="checkEmail"
                    @input="handleCC"
                />
            </div>
        </div>
        <div v-if="toggleBCC" class="form-group row" >
            <label class="col-form-label col-sm-3">BCC:</label>
            <div class="col-sm-9">
                <vue-tags-input
                    v-model="bcc"
                    :tags="value.Bcc || []"
                    :placeholder="translate('emailAddress')"
                    @tags-changed="newTags => value.Bcc = newTags.map(x => x.text.toLowerCase())"
                    :save-on-key="[13]"
                    :seperators="[':', ';', ' ']"
                    :addOnKey="[9, 13, 32, 44, 58, 59]"
                    :allow-edit-tags="true"
                    :allow-duplicates="false"
                    @before-adding-tag="checkEmail"
                    @input="handleBCC"
                />
            </div>
        </div>
        <div class="text-right" v-show="!showBcc()">
            <button @click="toggleBCC = true" type="button" class="btn btn-link" :title="translate('targetSystem.email.addBCCTitle')">{{translate('targetSystem.email.addBCC')}}</button>
        </div>
        <div class="form-group row">
            <label class="col-form-label col-sm-3">{{translate('targetSystem.email.subject')}}</label>
            <div class="col-sm-9">
                <input @input="checkInput('Subject',$event)" v-model="value.Subject" type="text" class="form-control" required />
            </div>
        </div>
        <div class="form-group">
            <label>{{translate('targetSystem.email.body')}}</label>
            <text-area-input v-model="value.Body" className="form-control" :maxlength="2000" rows="3" required />
            <!-- <textarea v-model="value.Body" class="form-control" maxlength="2000" rows="3" required></textarea> -->
        </div>
    </div>
</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input';  // http://www.vue-tags-input.com/#/start
import TextAreaInput from '../TextAreaInput.vue';

export default {
    components: {
        VueTagsInput,
        TextAreaInput
    },
    props: ['value'],
    data(){
        return {
            toggleCC: false,
            toggleBCC: false,
            tags: [],
            to: '',
            cc: '',
            bcc: ''
        }
    },
    created() {
        this.checkEmpty();
    },
    methods: {
        handleTo(newTo) {
            if (/[<>]/.test(newTo)) {
                alert(this.translate('errors.invalidSymbols'));
                this.$nextTick(() => {
                this.to = '';
                });
            } else {
                this.to = newTo;
            }
        },
        handleCC(newCC) {
            if (/[<>]/.test(newCC)) {
                alert(this.translate('errors.invalidSymbols'));
                this.$nextTick(() => {
                this.cc = '';
                });
            } else {
                this.cc = newCC;
            }
        },
        handleBCC(newBcc) {
            if (/[<>]/.test(newBcc)) {
                alert(this.translate('errors.invalidSymbols'));
                this.$nextTick(() => {
                this.bcc = '';
                });
            } else {
                this.bcc = newBcc;
            }
        },
        checkInput(val, event) {
            // Check for invalid characters
            if (/[<>]/.test(event.target.value)) {
                alert(this.translate('errors.invalidSymbols'))
                const editedText = ""
                this.$set(this.value, val, editedText)
            } else {
                this.$set(this.value, val, event.target.value)
            }
        },
        checkEmail(obj){
            var exp = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
            if (!obj.tag.text.match(exp))
                return;
            else if(obj.tag.text.match(/\.kep\.tr$/)) {
                alert(this.translate('errors.cantAddKepToEmailTarget'));
                return;
            }
            else 
                obj.addTag();
        },
        checkEmpty(){
            if(this.cc != ""){
                this.toggleCC = true;
            }
            else if (this.bcc != ""){
                this.toggleBCC = true;
            }
            else if(this.cc != "" && this.bcc != ""){
                this.toggleCC = true;
                this.toggleBCC = true;
            }
        },
        showCc(){
            if(this.value && this.value.Cc &&  this.value.Cc.length > 0){
                this.toggleCC = true;
            }
            return this.toggleCC;
        },
        showBcc(){
            if(this.value && this.value.Bcc &&  this.value.Bcc.length > 0){
                this.toggleBCC = true;
            }
            return this.toggleBCC;
        }
    }
}

</script>

